import { apiCommand } from "./index.jsx"
import _ from "lodash"
import moment from "moment"



export const addExpenseTypeStateTransition = stateTransition => async ( dispatch, getState ) => {
  const result = await apiCommand( dispatch, getState, "addExpenseTypeStateTransition", stateTransition )

  if ( result.message === "OK" ) {
    dispatch( {
      type: "ADD_EXPENSE_TYPE_STATE_TRANSITION",
      idExpenseType: result.result.idExpenseType,
      stateTransition: result.result,
    } )
  }

  return result
}


export const removeExpenseTypeStateTransition = st => async ( dispatch, getState ) => {
  const result = await apiCommand( dispatch, getState, "removeExpenseTypeStateTransition", {
    ...st,
  } )

  if ( result.message === "OK" ) {
    dispatch( {
      type: "REMOVE_EXPENSE_TYPE_STATE_TRANSITION",
      idExpenseType: st.idExpenseType,
      stateTransition: st,
    } )
  }

  return result
}



export const addAutomaticExpenseRule = rawAutomaticExpenseRule => async ( dispatch, getState ) => {
  const automaticExpenseRule = {
    ...rawAutomaticExpenseRule,
    startDate: moment( rawAutomaticExpenseRule.startDate ).format( "YYYY-MM-DD" ),
    endDate: rawAutomaticExpenseRule.endDate &&
      moment( rawAutomaticExpenseRule.endDate ).format( "YYYY-MM-DD" ),
  }
  const result = await apiCommand( dispatch, getState, "addAutomaticExpenseRule", automaticExpenseRule )

  if ( result.message === "OK" ) {
    dispatch( {
      type: "ADD_AUTOMATIC_EXPENSE_RULE",
      idExpenseType: result.result.idExpenseType,
      automaticExpenseRule: result.result,
    } )
  }

  return result
}

export const removeAutomaticExpenseRule = id => async ( dispatch, getState ) => {
  const result = await apiCommand( dispatch, getState, "removeAutomaticExpenseRule", {
    id,
  } )

  if ( result.message === "OK" ) {
    dispatch( { type: "REMOVE_AUTOMATIC_EXPENSE_RULE", id } )
  }

  return result
}

export const updateExpenseType = expenseType => async ( dispatch, getState ) => {
  const cleanExpenseType = _.pick( expenseType, [
    "id", "name", "billingPhase",
    "debtPhase", "automaticExpensesEnabled",
  ] )
  const result = await apiCommand( dispatch, getState, "updateExpenseType", cleanExpenseType )

  if ( result.message === "OK" ) {
    dispatch( {
      type: "UPDATE_EXPENSE_TYPE",
      expenseType,
    } )
  }
}

export const addExpenseType = expenseType => async ( dispatch, getState ) => {
  const result = await apiCommand( dispatch, getState, "addExpenseType", expenseType )

  if ( result.message === "OK" ) {
    dispatch( {
      type: "ADD_EXPENSE_TYPE",
      expenseType: result.result,
    } )
  }
}


export const getAllExpenseTypes = () => async ( dispatch, getState ) => {
  const result = await apiCommand( dispatch, getState, "getExpenseTypes" )

  if ( result.message === "OK" ) {
    dispatch( {
      type: "BULK_ADD_EXPENSE_TYPE",
      expenseTypes: result.result,
    } )
  }
}

export const removeExpenseType = id => async ( dispatch, getState ) => {
  const result = await apiCommand( dispatch, getState, "removeExpenseType", { id } )

  if ( result.message === "OK" ) {
    dispatch( { type: "REMOVE_EXPENSE_TYPE", id } )
  }
}


export const createExpense = values => async ( dispatch, getState ) => {
  const expense = _.omit( values, [ "receipt" ] )
  const result = await apiCommand( dispatch, getState, "addExpense", expense, {
    receipt: values.receipt,
  } )

  if ( result.message === "OK" ) {
    dispatch( { type: "ADD_EXPENSE", expense: result.data } )
  }

  return result
}

export const removeExpense = id => async ( dispatch, getState ) => {
  const result = await apiCommand( dispatch, getState, "removeExpense", { id } )

  if ( result.message === "OK" ) {
    dispatch( { type: "REMOVE_EXPENSE", id } )
  }

  return result
}

export const getExpenseReceipt = id => async ( dispatch, getState ) => {
  const res = await apiCommand( dispatch, getState, "getExpenseReceipt", { id } )
  return await res.blob()
}

export const updateExpense = values => async ( dispatch, getState ) => {
  const expense = _.pick( values, [
    "id",
    "expenseType",
    "value",
    "details",
    "expenseDate",
    "documentNumber",
  ] )
  const result = await apiCommand( dispatch, getState, "updateExpense", expense, {
    receipt: values.receipt,
  } )

  if ( result.message === "OK" ) {
    dispatch( { type: "UPDATE_EXPENSE", expense: result.data } )
  }

  return result
}

export const searchDebtPhasesByExpense = rawSearchCriteria => async ( dispatch, getState ) => {
  const searchCriteria = _.pick( rawSearchCriteria, [
    "billingPhase",
    "debtPhase",
    "clientName",
    "segment",
    "expenseDateStart",
    "expenseDateEnd",
  ] )

  const response = await apiCommand( dispatch, getState, "searchDebtPhasesByExpense", searchCriteria )
  if ( response.message !== "OK" ) {
    throw new Error( response.message )
  }

  return response.result
}



// WEBPACK FOOTER //
// ./src/actions/expenses.jsx